<template>
  <v-card :min-width="isMdAndDown ? '25vw' : '20vw'">
    <v-container class="py-0">
      <v-row
        v-if="loginMode !== 0 && loggedInUser" class="pl-1" align="center"
        align-content="center" justify="center">
        <v-col cols="3" class="text-right">
          <v-avatar id="container" size="40" class="mr-4">
            <img
              v-if="user && user.avatar" id="avatar" :src="getAvatar()"
              alt="GDi Smart Portal" contain>
            <v-icon v-else size="64">
              mdi-account
            </v-icon>
            <v-icon v-if="user && user.avatar" id="settings">
              mdi-account-cog-outline
            </v-icon>
          </v-avatar>
        </v-col>
        <v-col cols="9" class="text-left">
          <v-row class="shrink">
            <span :style="{fontSize: '16px', color: info, opacity: '0.6'}">
              {{ loggedInUser }}
            </span>
          </v-row>
          <v-row>
            <span :style="{fontSize: '14px', color: info, opacity: '0.6'}">
              {{ user.email }}
            </span>
          </v-row>
        </v-col>
      </v-row>
      <v-divider v-if="loginMode !== 0 && loggedInUser" />
      <v-row>
        <v-list class="px-0 py-2" style="width: 100%;">
          <v-list-item style="min-height:30px" dense @click="showSettings">
            <v-icon
              small dense color="widgetText"
              style="opacity: 0.6">
              mdi-cog
            </v-icon>
            <span :style="{fontSize: '14px', color: info, opacity: '0.6'}" class="pl-2">
              {{ labels.settings }}
            </span>
          </v-list-item>
          <v-list-item style="min-height:30px" dense @click="appInfo">
            <v-icon
              small dense color="widgetText"
              style="opacity: 0.6">
              mdi-information-outline
            </v-icon>
            <span :style="{fontSize: '14px', color: info, opacity: '0.6'}" class="pl-2">
              {{ labels.about }}
            </span>
          </v-list-item>
          <v-list-item
            style="min-height:30px" dense
            @click="openManual">
            <v-icon
              small dense color="widgetText"
              style="opacity: 0.6">
              mdi-book-arrow-right-outline
            </v-icon>
            <span class="pl-2" :style="{fontSize: '14px', color: info, opacity: '0.6'}">
              {{ labels.manual }}
            </span>
          </v-list-item>
          <v-list-item
            v-if="loginMode !== 0 && loggedInUser" class="ma-0" style="min-height:30px"
            dense @click="logout">
            <v-icon
              small dense color="widgetText"
              style="opacity: 0.6">
              mdi-logout
            </v-icon>
            <span class="pl-2" :style="{fontSize: '14px', color: info, opacity: '0.6'}">
              {{ labels.logout }}
            </span>
          </v-list-item>
          <v-list-item
            v-if="loginMode === 2 && !loggedInUser" style="min-height:30px" dense
            @click="goToLogin">
            <v-icon
              small dense color="widgetText"
              style="opacity: 0.6">
              mdi-login
            </v-icon>
            <span class="pl-2" :style="{fontSize: '14px', color: info, opacity: '0.6'}">
              {{ labels.goToLogin }}
            </span>
          </v-list-item>
          <v-list-item v-for="(customTool, index) in customTools" :key="index" @click="startTool(customTool)">
            <v-icon
              small dense color="info"
              style="opacity: 0.6">
              {{ customTool.icon }}
            </v-icon>
            <span class="pl-2" :style="{fontSize: '14px', color: info, opacity: '0.6'}">
              {{ customTool.title[language] }}
            </span>
          </v-list-item>
        </v-list>
      </v-row>
      <v-divider />
      <v-row class="pl-3">
        <div
          v-for="(item, index) in languages" :key="index"
          class="pa-1 ma-0"
          cols="3"
          @click="setLanguage(item)">
          <v-btn
            fab x-small dense
            color="widgetText--text"
            elevation="0">
            {{ item.title }}
          </v-btn>
        </div>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import axios from 'axios'
import proxy from '../../proxy/proxy'
import esriId from '@arcgis/core/identity/IdentityManager'
import * as intl from '@arcgis/core/intl'
export default {
  name: 'ContextMenu',
  data () {
    return {
      languages: [],
    }
  },
  computed: {
    user () {
      return this.$store.getters.getLoggedInUser ? this.$store.getters.getLoggedInUser : null
    },
    loggedInUser () {
      return this.user ? this.user.name + ' ' + this.user.surname : ''
    },
    configJson () {
      return this.$store.getters.getConfigJson
    },
    loginMode () {
      return this.$store.getters.getHasLogin
    },
    language () {
      return this.$store.getters.getLanguage
    },
    labels () {
      return this.getLabels(this.$store.getters.getLanguage).home
    },
    colorSchema () {
      return this.$store.getters.getConfigJson.colorSchema
    },
    info () {
      return this.colorSchema.widgetText
    },
    isMdAndDown () {
      return this.$vuetify.breakpoint.mdAndDown
    },
    customTools () {
      let ret = []
      const customTools = this.configJson.customTools
      if (!customTools) {
        return ret
      }
      ret = customTools.filter(element => element.btnPosition === 'contextMenu')
      return ret
    },
  },
  created () {
    if (this.configJson.appConfig) {
      const appConfig = this.configJson.appConfig
      if (appConfig.localization) {
        for (const localization of appConfig.localization) {
          const language = {
            id: localization.id,
            title: localization.id,
          }
          if (language.title === 'cir') {
            language.title = 'ср'
          }
          this.languages.push(language)
        }
      }
    }
  },
  methods: {
    getAvatar () {
      return this.user?.avatar ? 'data:image/jpeg;base64,' + this.user.avatar : null
    },
    showSettings () {
      this.$emit('settings-clicked')
    },
    appInfo () {
      this.$emit('about-clicked', true)
    },
    openManual () {
      let url = ''
      if (this.$store.getters.getLanguage === 'en') {
        if (this.configJson?.appConfig?.userManual?.en) {
          url = this.configJson.appConfig.userManual.en
        } else {
          url = process.env.VUE_APP_USER_MANUAL_EN
        }
      } else if (this.configJson?.appConfig?.userManual?.sr) {
        url = this.configJson.appConfig.userManual.sr
      } else {
        url = process.env.VUE_APP_USER_MANUAL_SR
      }
      window.open(url, '_blank').focus()
    },
    async logout () {
      this.$store.dispatch('resetVuex')
      this.$store.dispatch('setViewObject', null)
      // remove portal access token if it exists
      esriId.destroyCredentials()
      const viewerName = this.$store.getters.getViewerName
      localStorage.removeItem(window.location.host + '-' + viewerName + '-loggedInUser')
      if (this.$store.getters.getHasLogin === 2) {
        const input = {
          viewerfk: this.$store.getters.getViewerId,
          organisationfk: this.$store.getters.getOrganisationId,
        }
        try {
          const response = await axios.post('mixedAuth', input)
          const mixedInfo = response.data
          this.$store.dispatch('doMixedAuth', mixedInfo)
          const token = this.$store.getters.getAccessToken
          proxy(token, this.$store.getters.getConfigJson)
          this.$router.go()
        } catch (error) {
          console.error(error)
        }
      } else {
        this.$router.push('/' + this.$store.getters.getViewerName + '/login')
      }
    },
    goToLogin () {
      esriId.destroyCredentials()
      // same as the comment below
      this.$store.dispatch('setArcGISPortalToken', null)
      // covers mixed mode scenario (vuex persists so we have to set layersLoaded to false again)
      this.$store.dispatch('setLayersLoaded', false)
      this.$router.push('/' + this.$store.getters.getViewerName + '/login')
    },
    setLanguage (item) {
      if (['sr', 'cir'].includes(item.id)) {
        intl.setLocale('sr')
      } else {
        intl.setLocale('en-US')
      }
      const data = {
        language: item.id,
        viewer: this.$store.getters.getViewerName,
        host: window.location.host,
      }
      this.$store.dispatch('setLanguage', data)
    },
    getLanguageIcon (title) {
      return require('./../../assets/languages/' + title + '.png')
    },
    startTool (item) {
      if (item.position === 'side') {
        this.$store.dispatch('setActiveTool', item.id)
      } else {
        this.$store.dispatch('storeCenterActiveTool', item.id)
      }
    },
  },
}
</script>
<style scoped>
#avatar {
  opacity: 1;
  transition: .5s ease;
  backface-visibility: hidden;
}
#settings{
  transition: .5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}
#container:hover #avatar {
  opacity: 0.3;
  cursor: pointer;
}

#container:hover #settings {
  opacity: 1;
  cursor: pointer;
}
</style>
